import React from 'react'
import { Anchor } from '@mantine/core'
import { IconBriefcase, IconMail, IconMapPin, IconPhone } from '@tabler/icons-react'

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-gray-900 to-black text-gray-300 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gray-700 to-transparent"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5 space-y-6">
            <div>
              <h3 className="text-3xl font-bold text-white mb-3">优查查</h3>
              <p className="text-sm text-gray-400 leading-relaxed max-w-md">
                由四川捷创优信科技有限公司提供，专注为租赁、家政、人力、小微企业等场景提供合规、易用的风险评估与背景核查服务。
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">联系我们</h4>
              <ul className="space-y-4">
                <li>
                  <div className="flex items-start gap-3 group">
                    <IconMail
                      size={18}
                      className="text-orange-400 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
                    />
                    <div>
                      <div className="text-xs text-gray-500 mb-1">客服邮箱</div>
                      <Anchor
                        href="mailto:service@youchacha.com"
                        className="text-gray-300 hover:text-orange-400 transition-colors duration-300 text-sm"
                      >
                        service@youchacha.com
                      </Anchor>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex items-start gap-3 group">
                    <IconBriefcase
                      size={18}
                      className="text-orange-400 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
                    />
                    <div>
                      <div className="text-xs text-gray-500 mb-1">商务合作</div>
                      <Anchor
                        href="mailto:bd@youchacha.com"
                        className="text-gray-300 hover:text-orange-400 transition-colors duration-300 text-sm"
                      >
                        bd@youchacha.com
                      </Anchor>
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">服务热线</h4>
              <ul className="space-y-4">
                <li>
                  <div className="flex items-start gap-3 group">
                    <IconPhone
                      size={18}
                      className="text-orange-400 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform duration-300"
                    />
                    <div>
                      <div className="text-xs text-gray-500 mb-1">客服电话</div>
                      <Anchor
                        href="tel:400-XXX-XXXX"
                        className="text-gray-300 hover:text-orange-400 transition-colors duration-300 text-sm"
                      >
                        400-XXX-XXXX
                      </Anchor>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="flex items-start gap-3">
                    <IconMapPin size={18} className="text-orange-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="text-xs text-gray-500 mb-1">公司地址</div>
                      <div className="text-sm text-gray-300">四川省 成都市</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 text-xs text-gray-500">
              <span>© 2024 四川捷创优信科技有限公司</span>
              <span className="hidden lg:inline">·</span>
              <Anchor
                href="https://beian.miit.gov.cn/"
                target="_blank"
                className="text-gray-500 hover:text-orange-400 transition-colors duration-300"
              >
                蜀ICP备2024054454号
              </Anchor>
            </div>
            <div className="flex flex-wrap justify-center gap-6 text-xs">
              <Anchor
                href="privacyPolicy.html"
                className="text-gray-500 hover:text-orange-400 transition-colors duration-300"
              >
                隐私政策
              </Anchor>
              <Anchor
                href="userAgreement.html"
                className="text-gray-500 hover:text-orange-400 transition-colors duration-300"
              >
                服务条款
              </Anchor>
              <Anchor href="#" className="text-gray-500 hover:text-orange-400 transition-colors duration-300">
                数据合规说明
              </Anchor>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
